import { render, staticRenderFns } from "./WapFileDetails.vue?vue&type=template&id=16f17be4&scoped=true&"
import script from "./WapFileDetails.vue?vue&type=script&lang=js&"
export * from "./WapFileDetails.vue?vue&type=script&lang=js&"
import style0 from "./WapFileDetails.vue?vue&type=style&index=0&id=16f17be4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f17be4",
  null
  
)

export default component.exports